




























































import { RecentActivityTile } from '@/components/dashboard';
import { Skill } from '@/models';
import { RecentActivity } from '@/models/dashboard';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';
import SkillIcon from '@/views/leaderboard/SkillIcon.vue';

export default Vue.extend({
  name: 'RecentActivities',
  components: {
    RecentActivityTile: () => Promise.resolve(RecentActivityTile),
    SkillIcon,
  },
  data() {
    return {
      loader: {
        areRecentActivitiesPending: false,
      },
      filters: {
        immediate: {
          skill: Skill.General,
        },
      },
      skills: Object.values(Skill),
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 10,
        slidesPerGroup: 6,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          992: {
            slidesPerView: 4,
            spaceBetween: 10,
            slidesPerGroup: 4,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
            slidesPerGroup: 3,
          },
          576: {
            slidesPerView: 1,
            spaceBetween: 10,
            slidesPerGroup: 1,
          },
        },
      },
    };
  },
  created() {
    this.fetchRecentActivities();
  },
  computed: {
    activities(): RecentActivity[] {
      return typedStore(this).state.activities.geeksRecentActivities;
    },
  },
  methods: {
    async fetchRecentActivities() {
      this.loader.areRecentActivitiesPending = true;
      try {
        await this.$store.dispatch(Actions.activities.fetchRecentActivities,  this.filters.immediate.skill);
      } finally {
        this.loader.areRecentActivitiesPending = false;

        if (this.$refs.recentActivitiesSwiper) {
          (this.$refs.recentActivitiesSwiper as any).swiper.slideTo(0, 0);
        }
      }
    },
    isActiveSkill(skill: Skill): boolean {
      return skill === this.filters.immediate.skill;
    },
    setActiveSkill(skill: Skill) {
      this.filters.immediate.skill = skill;
    },
  },
  watch: {
    'filters.immediate': {
      handler(this: any) {
        this.fetchRecentActivities();
      },
      deep: true,
    },
  },
});
